/* V9.4: local, muted previews. Never manufactures product or purchase state. */
(() => {
  'use strict';
  const tr = (key, params) => window.storeTranslate(key, params);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mediaInstances = new Set();
  function init(scope = document) {
    scope.querySelectorAll('.u7-gallery:not([data-v96-ready])').forEach(gallery => {
      gallery.dataset.v96Ready = 'true';
      const rail = gallery.querySelector('[data-gallery-thumbs]');
      const prev = document.createElement('button'), next = document.createElement('button');
      for (const [button, direction] of [[prev,'prev'],[next,'next']]) {
        button.type = 'button';button.className = 'v96-rail-button';button.setAttribute('data-v96-rail-'+direction,'');
        button.setAttribute('aria-label',direction==='prev'?tr('s039'):tr('s040'));
        button.textContent = direction==='prev'?'‹':'›';
        button.addEventListener('click',()=>rail.scrollBy({left:(direction==='prev'?-1:1)*rail.clientWidth*.8,behavior:reduced.matches?'instant':'smooth'}));
      }
      rail.before(prev);rail.after(next);
      const syncRail=()=>{prev.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
      rail.addEventListener('scroll',syncRail,{passive:true});new ResizeObserver(syncRail).observe(rail);syncRail();
    });
    scope.querySelectorAll('[data-v94-film]:not([data-v94-ready])').forEach(card => {
      card.dataset.v94Ready = 'true';
      const loop = card.querySelector('[data-v94-loop]');
      const toggle = card.querySelector('[data-v94-loop-toggle]');
      const opener = card.querySelector('[data-v94-film-open]');
      const dialog = card.querySelector('[data-v94-film-dialog]');
      const player = card.querySelector('[data-v94-film-player]');
      let inView = false, userPaused = false, userOptedIn = false;
      function sync() {
        toggle.textContent = loop.paused ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', loop.paused ? tr('s041') : tr('s042'));
        toggle.setAttribute('aria-pressed', String(!loop.paused));
      }
      function maybePlay() {
        if (!inView || document.hidden || dialog.open || userPaused || (reduced.matches && !userOptedIn) || navigator.connection?.saveData) {
          loop.pause(); return;
        }
        loop.muted = true;
        loop.play().catch(sync);
      }
      toggle.addEventListener('click', () => {
        if (loop.paused) { userPaused = false; userOptedIn = true; loop.muted = true; loop.play().catch(sync); }
        else { userPaused = true; loop.pause(); }
      });
      loop.addEventListener('play', sync);
      loop.addEventListener('pause', sync);
      loop.addEventListener('error', () => { toggle.textContent = tr('s043'); toggle.disabled = true; });
      opener.addEventListener('click', () => {
        dialog.showModal();
        loop.pause();
        document.body.classList.add('v94-film-is-open');
        player.play().catch(() => {}); // Native controls remain usable if playback is blocked.
      });
      card.querySelector('[data-v94-film-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        player.pause(); document.body.classList.remove('v94-film-is-open'); opener.focus({preventScroll:true}); maybePlay();
      });
      player.addEventListener('error', () => {card.querySelector('[data-v94-film-error]').hidden = false;});
      const observer = new IntersectionObserver(entries => {inView = entries[0].isIntersecting; maybePlay();}, {threshold: .35});
      observer.observe(loop);
      function preferenceChanged() {userOptedIn = false; maybePlay();}
      reduced.addEventListener('change', preferenceChanged);
      document.addEventListener('visibilitychange', maybePlay);
      mediaInstances.add({card, dispose() {observer.disconnect(); loop.pause(); player.pause(); reduced.removeEventListener('change',preferenceChanged); document.removeEventListener('visibilitychange',maybePlay);}});
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const entry of mediaInstances) if (event.target.contains(entry.card)) {entry.dispose(); mediaInstances.delete(entry);}
    if (!document.querySelector('[data-v94-film-dialog][open]')) document.body.classList.remove('v94-film-is-open');
  });
  // Shopify's preview toolbar is a separate fixed iframe. Keep the draft purchase bar above it.
  let frame = 0;
  function measure() {
    frame = 0;
    let inset = 0;
    document.querySelectorAll('#PBarNextFrameWrapper, iframe').forEach(el => {
      if (el.id !== 'PBarNextFrameWrapper' && !/preview-bar/.test(el.id + ' ' + el.src)) return;
      const rect = el.getBoundingClientRect();
      if (rect.width > innerWidth * .6 && rect.top > innerHeight / 2 && rect.top < innerHeight && rect.bottom >= innerHeight - 2) inset = Math.max(inset, innerHeight - rect.top);
    });
    document.body.style.setProperty('--v94-preview-inset', Math.ceil(inset) + 'px');
    const bar = document.querySelector('[data-u7-sticky]');
    if (bar) document.body.style.setProperty('--v94-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
  }
  function schedule() {if (!frame) frame = requestAnimationFrame(measure);}
  const resize = new ResizeObserver(schedule);
  const watched = new WeakSet();
  function watch() {
    for (const el of document.querySelectorAll('[data-u7-sticky], #PBarNextFrameWrapper, iframe')) if (!watched.has(el)) {watched.add(el); resize.observe(el);}
    schedule();
  }
  new MutationObserver(watch).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('resize',schedule);
  document.addEventListener('shopify:section:load',watch);
  watch();
})();
